import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { GameState } from '../../models/game-state.model';

@Injectable({
  providedIn: 'root',
})
export class GameStateService {
  private readonly http = inject(HttpClient);

  getGameState(): Observable<GameState> {
    return this.http.get<GameState>(
      `${environment.apiUrl}/game-state`,
    );
  }
}
